import {IT} from "./IT";
import {EN} from "./EN";
import {UA} from "./UA";

export const langDict = {
	"it": {
		label: "Italiano",
		flag: <img width={28} src="https://flagcdn.com/it.svg" alt={"Bandiera italia"}
		           style={{marginRight: 3}}/>
	},
	"en": {
		label: "English",
		flag: <img width={28} src="https://flagcdn.com/gb.svg" alt={"United Kingdom flag"}
		           style={{marginRight: 3}}/>
	},
	"ua": {
		label: "український",
		flag: <img width={28} src="https://flagcdn.com/ua.svg" alt={"United Kingdom flag"}
		           style={{marginRight: 3}}/>
	},
}

export const languages = {
	"it": IT,
	// "en": EN,
	// "ua": UA,
}
